import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from "react-oidc-context";
import { UserProvider } from './context/UserContext';

// @TODO: get this from a configuration
const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_esZOi5PQN",
  client_id: "7ksdbouuulkoo6roe0fshhqknv",
  redirect_uri: window.location.origin,
  response_type: "code",
  scope: "email openid",
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
  <AuthProvider {...cognitoAuthConfig}>
    <UserProvider>
      <App />
    </UserProvider>
  </AuthProvider>
  </React.StrictMode>
);
